import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Pet, PetGender } from 'src/app/interfaces/pet';
import { KeeperResponseStatus } from 'src/app/interfaces/user';

import { PetService } from 'src/app/services/pet/pet.service';
import { Alert } from 'src/app/interfaces/alert';

@Component({
  selector: 'app-tok-consent',
  templateUrl: './tok-consent.component.html',
  styleUrls: ['./tok-consent.component.scss']
})

export class TokConsentComponent implements OnInit {
  chipNumber: string | null = null;
  autoResolveConsent: string | null = null;
  petName: string = ' - ';
  petSpecies: string = ' - ';
  dateOfBirth: Date | string = ' - ';
  implantDate: Date | string = ' - ';
  breed: string = ' - ';
  gender: PetGender | string = ' - ';
  petImagePath: string = '/assets/images/placeholders/paw.png';
  showButtons: boolean = true;
  alert: Alert = null;
  cardBottomText: string;
  shouldShowCardBottomText: boolean;

  constructor(
    private route: ActivatedRoute,
    private petService: PetService
  ) {}

  ngOnInit(): void {
    this.shouldShowCardBottomText = !this.showButtons && this.alert === null;
    this.route.queryParamMap.subscribe(params => {
      this.chipNumber = params.get('chipnumber');
      this.autoResolveConsent = params.get('value');
    });
    if (this.chipNumber) {
      this.petService.getTokFromChipNumber(this.chipNumber).subscribe((data: Pet) => {
        this.petName = data.name;
        this.petSpecies = data.species;
        this.dateOfBirth = this.getDateOfBirthString(data.dob);
        this.implantDate = this.getDateOfBirthString(data.implantDate);
        this.breed = data.breed;
        this.gender = PetGender[data.gender];
        if (data.imageUrl) {
          this.petImagePath = data.imageUrl;
        }
      })
      if (this.autoResolveConsent) {
        this.showButtons = false
        const keeperResponseStatusToSend = Number(this.autoResolveConsent) === 0 ? KeeperResponseStatus.ConsentDeniedResponse : KeeperResponseStatus.ConsentGivenResponse
        this.consentGivenButtonsClick(keeperResponseStatusToSend);
      }
    }
  }

  private getDateOfBirthString(date: Date): string {
    const day = new Date(date).getDate();
    const month = new Date(date).getMonth() + 1;
    const year = new Date(date).getFullYear();
    return `${day}/${month}/${year}`;
  }

  closeAlert() {
    this.alert = null;
  }

  public consentGivenButtonsClick(keeperResponseStatus: KeeperResponseStatus) {
    this.petService.closeTokStatus(this.chipNumber, keeperResponseStatus).subscribe({
      next: () => {
        this.showButtons = false
        this.shouldShowCardBottomText = true;
        this.cardBottomText = keeperResponseStatus === KeeperResponseStatus.ConsentGivenResponse ? 
        "Thank you for your response, we will now update the keepership of this pet." :
        "Thank you for your response, a member of the team will be in touch in the next 48 hours to discuss this further.";
      },
      error: error => {
        this.alert = { 
          type: 'danger', 
          message: error.error.error_code === 'open_tok_not_found' ?
          "Your response to this request has already been recorded. If you need to amend your response, please contact our team on 0330 9128077" :
          error.error.error_message
        }
      }
    });
  }
}
